import Input, { TextAreaProps } from 'antd/lib/input';
import React, { FC } from 'react';

const TextArea: FC<TextAreaProps> = ({ ...props }) => {
  return <Input.TextArea {...props} />;
};

export { TextArea };
